import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import ge from "./base-device-parser.js";
import { Browsers as gi, OperatingSystems as so } from "./device-constants.js";
var oi = /*#__PURE__*/function (_ge) {
  _inherits(oi, _ge);
  var _super = _createSuper(oi);
  function oi() {
    var _this;
    _classCallCheck(this, oi);
    _this = _super.call(this), _this.fd = oi.gc(navigator.userAgent || "");
    return _this;
  }
  _createClass(oi, [{
    key: "ef",
    value: function ef() {
      return this.fd[0] || "Unknown Browser";
    }
  }, {
    key: "ff",
    value: function ff() {
      return this.fd[1] || "Unknown Version";
    }
  }, {
    key: "Ja",
    value: function Ja(r) {
      for (var n = 0; n < r.length; n++) {
        var e = r[n].string;
        var i = oi.nf(e, r[n]);
        if (i) return i === so.Og && navigator.maxTouchPoints > 1 && (i = so.co), Promise.resolve(i);
      }
      return Promise.resolve(navigator.platform);
    }
  }], [{
    key: "gc",
    value: function gc(r) {
      var n,
        e = r.match(/(samsungbrowser|tizen|roku|konqueror|icab|crios|opera|ucbrowser|chrome|safari|firefox|camino|msie|trident(?=\/))\/?\s*(\.?\d+(\.\d+)*)/i) || [];
      if (-1 !== r.indexOf("(Web0S; Linux/SmartTV)")) return ["LG Smart TV", null];
      if (-1 !== r.indexOf("CrKey")) return ["Chromecast", null];
      if (-1 !== r.indexOf("BRAVIA") || -1 !== r.indexOf("SonyCEBrowser") || -1 !== r.indexOf("SonyDTV")) return ["Sony Smart TV", null];
      if (-1 !== r.indexOf("PhilipsTV")) return ["Philips Smart TV", null];
      if (r.match(/\b(Roku)\b/)) return ["Roku", null];
      if (r.match(/\bAFTM\b/)) return ["Amazon Fire Stick", null];
      if (e[1] === gi.rO && (n = r.match(/\b(OPR|Edge|EdgA|Edg|UCBrowser)\/(\.?\d+(\.\d+)*)/), null != n)) return n = n.slice(1), n[0] = n[0].replace("OPR", gi.oO), n[0] = n[0].replace("EdgA", gi.eO), "Edg" === n[0] && (n[0] = gi.eO), [n[0], n[1]];
      if (e[1] === gi.xg && (n = r.match(/\b(EdgiOS)\/(\.?\d+(\.\d+)*)/), null != n)) return n = n.slice(1), n[0] = n[0].replace("EdgiOS", gi.eO), [n[0], n[1]];
      if (e = e[2] ? [e[1], e[2]] : [null, null], e[0] === gi.xg && null != (n = r.match(/version\/(\.?\d+(\.\d+)*)/i)) && e.splice(1, 1, n[1]), null != (n = r.match(/\b(UCBrowser)\/(\.?\d+(\.\d+)*)/)) && e.splice(1, 1, n[2]), e[0] === gi.oO && null != (n = r.match(/mini\/(\.?\d+(\.\d+)*)/i))) return ["Opera Mini", n[1] || ""];
      if (e[0]) {
        var _r = e[0].toLowerCase();
        "crios" === _r && (e[0] = gi.rO), "tizen" === _r && (e[0] = "Samsung Smart TV", e[1] = null), "samsungbrowser" === _r && (e[0] = "Samsung Browser");
      }
      return e;
    }
  }]);
  return oi;
}(ge);
export { oi as default };